import * as analytics from '@opendoor/shared-fe/build/analytics';

const OPTIMIZELY_WEB = 'optimizely-web';
const CONTEXT = 'seller_onboarding';

// segment event is forwarded to both Opt Web and Opt FS
export const leadQualifyConversionEvent = (payload: any) => {
  analytics.trackEvent(CONTEXT, 'lead_qualify_conversion', OPTIMIZELY_WEB, payload);
};

export const emailConversionEvent = (payload: any) => {
  analytics.trackEvent(CONTEXT, 'email_conversion', OPTIMIZELY_WEB, payload);
};
